exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".alert-container{\r\n    margin: 0 10;\r\n}\r\n\r\nImage\r\n{\r\n    max-width: 100%;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1!./~/postcss-loader!./src/components/ExamForm/ExamForm.css
// module id = 2993
// module chunks = 0